import { persistentAtom } from "@nanostores/persistent";
import type { LoginTokenResponse } from "../types/cms/login";

interface AuthState {
  userData: LoginTokenResponse | null;
  isAdminAuthenticated: boolean;
}

const initialState: AuthState = {
  userData: null,
  isAdminAuthenticated: false,
};

export const $cmsAuth = persistentAtom<AuthState>("cms-auth", initialState, {
  encode: JSON.stringify,
  decode: JSON.parse,
});

export const loginCms = (loginResponse: LoginTokenResponse) => {
  $cmsAuth.set({
    userData: loginResponse,
    isAdminAuthenticated: true,
  });
};

export const logoutCms = () => {
  $cmsAuth.set(initialState);
  window.location.replace("/cms/login");
};
